/**
 * @file header-store.js
 */
import state from './state';
import getters from './getters/index';
import mutations from './mutations';
import actions from './actions';

export default {
    state,
    getters,
    mutations,
    actions
};
